import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyGetOrderDetailByIdQuery } from "../../services/order";
import { ImageModal } from "../../components";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";

const ProductsOrdered = () => {
  const { _id } = useParams();
  const t = useTranslation();
  const [fetchApi] = useLazyGetOrderDetailByIdQuery();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");

  const fetchDataById = async () => {
    try {
      const response = await fetchApi(_id).unwrap();
      if (response.status === 200) {
        const data = response.data;
        const extractedData = {
          name: data?.user,
          phoneNo: `${data?.country_code} ${data.phone_no}`,
          orderStatus: data?.order_status,
          subTotal: data?.sub_total,
          deliveryFees: data?.delivery_fees,
          totalCostPay: data?.total_cost_pay,
          orderTrackId: data?.order_track_id,
          address: data.address?.business_address || "-",
          city: data?.address?.city || "-",
          pinCode: data?.address?.pin_code || "-",
          products:
            data.product?.map((prod: any) => ({
              productName: prod?.product_name_en,
              minQuantity: prod?.min_quantity,
              pricePerUnit: prod?.price_per_unit,
              buyQuantity: prod?.buy_quantity,
              buyPrice: prod?.buy_price,
              images:
                prod?.product_image?.map((img: any) => img?.media_url) || [],
            })) || [],
        };
        setOrderDetails(extractedData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchDataById();
    }
  }, [_id]);

  const handleOpenModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card className="cards">
      <CardContent sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom>
          {t.main.orderDetails}
        </Typography>
        {orderDetails && (
          <Box>
            <Typography variant="body1">
              <strong>{t.main.name}:</strong> {orderDetails.name}
            </Typography>
            <Typography variant="body1">
              <strong>{t.main.phoneNumber}:</strong> {orderDetails.phoneNo}
            </Typography>
            <Typography variant="body1">
              <strong>{t.main.address}:</strong> {orderDetails.address},{" "}
              {orderDetails.city}, {orderDetails.pinCode}
            </Typography>
            <Typography variant="body1">
              <strong>{t.main.orderStatus}:</strong>{" "}
              {orderDetails.orderStatus === 1
                ? "Order Placed"
                : orderDetails?.orderStatus === 2
                  ? "In-Progress"
                  : orderDetails?.orderStatus === 3
                    ? "shipping"
                    : orderDetails?.orderStatus === 4
                      ? "Delivered"
                      : null}
            </Typography>
            <Typography variant="body1">
              <strong>{t.main.totalCost}:</strong>{" "}
              {currency === "USD" ? "USD" : "AED"}{" "}
              {orderDetails.totalCostPay || "0"}
            </Typography>
          </Box>
        )}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {orderDetails?.products?.map((product: any, index: number) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={4}>
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: 2,
                  textAlign: "center",
                }}
              >
                {product.images.length > 0 && (
                  <img
                    src={product.images[0]}
                    alt={product.productName}
                    style={{
                      width: "100%",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginBottom: "1rem",
                    }}
                    onClick={() => handleOpenModal(product.images[0])}
                  />
                )}
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {product.productName}
                </Typography>
                <Typography variant="body2">
                  <strong>{t.main.minQty}:</strong> {product.minQuantity}
                </Typography>
                <Typography variant="body2">
                  <strong>{t.main.pricePerUnit}:</strong>{" "}
                  {currency === "USD" ? "USD" : "AED"}{" "}
                  {product.pricePerUnit || "0"}
                </Typography>
                <Typography variant="body2">
                  <strong>{t.main.orderedQty}:</strong> {product.buyQuantity}
                </Typography>
                <Typography variant="body2">
                  <strong>{t.main.totalCost}:</strong>{" "}
                  {currency === "USD" ? "USD" : "AED"} {product.buyPrice || "0"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
      <ImageModal open={open} handleClose={handleClose} image={selectedImage} />
    </Card>
  );
};

export default ProductsOrdered;
